// extracted by mini-css-extract-plugin
export default {"loginBox":"LoginBox_loginBox__HiaAl","loginBoxTitle":"LoginBox_loginBoxTitle__0ZeHH"};